module.exports = __webpack_public_path__ + "static/media/won-sign.4e37a596.svg";